import { Action, createReducer, on } from '@ngrx/store';
import {
  updateAccountVisitsAction, updateAccountVisitsSuccessAction, updateAccountVisitsFailureAction,
} from './update-account-visits.actions';
import { UpdateAccountVisitsState } from './update-account-visits.types';

const initialState = {
  updating: false,
  updated: false,
  data: null,
  error: null,
};

const updateAccountVisitsReducer = createReducer<UpdateAccountVisitsState>(
  initialState,
  on(
    updateAccountVisitsAction,
    state => ({
      ...state,
      updating: true,
      updated: false,
    })
  ),
  on(
    updateAccountVisitsSuccessAction,
    (state, action) => ({
      ...state,
      updating: false,
      updated: true,
      data: action.data,
      error: null,
    })
  ),
  on(
    updateAccountVisitsFailureAction,
    (state, action) => ({
      ...state,
      updating: false,
      updated: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: UpdateAccountVisitsState, action: Action) => updateAccountVisitsReducer(state, action);
